import { computeNextViewLevel } from "./computeNextViewLevel";
import { computeViewLevel } from "./computeViewLevel";
import { getVisibleLayout } from "./getVisibleLayout";
import { logInfo } from "./layoutLogger";
export function computeVisibleLayout(layout, attributes) {
    // compute existing viewLevel in the layout
    const layoutWithLevels = computeViewLevel(layout, attributes);
    // compute next viewLevel and visible layout
    const nextViewLevel = computeNextViewLevel(layoutWithLevels);
    const visibleLayout = getVisibleLayout(layoutWithLevels, nextViewLevel);
    const requiredViewLevel = layoutWithLevels.requiredViewLevel;
    logInfo(`ViewLevel layout / required / next`, layout.id, requiredViewLevel, nextViewLevel);
    return visibleLayout;
}
//# sourceMappingURL=computeVisibleLayout.js.map